module.exports = __webpack_public_path__ + "static/Sphere 1 - Plastic and metal - Level 4-d618630fc2d0a555928987a85c723042.png";